<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :title="setId?'编辑文件':'新增文件'"
        :visible.sync="fileDialog"
        center
        width="600px">
        <el-form ref="fileForm" :model="fileForm" :rules="rules" label-width="100px">
            <el-form-item label="文件名称：" prop="name">
                <el-input v-model="fileForm.name" placeholder="请输入文件名称"></el-input>
            </el-form-item>
            <el-form-item label="上传文件：" prop="name">
                <el-upload
                    ref="upload"
                    :action="upUrl"
                    :before-upload="beforeAvatarUpload"
                    :data="QiniuData"
                    :file-list="fileList"
                    :limit="limit"
                    :name="'file'"
                    :on-exceed="handleExceed"
                    :on-preview="handlePreview"
                    :on-success="handleAvatarSuccess"
                >
                    <el-button plain type="primary"> + 点击添加文件</el-button>
                </el-upload>
            </el-form-item>

            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('fileForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('fileForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {FILE_UPLOAD_HOST_QN} from "@/config";
import {articleAdd, getQiniuUrl} from "@/api/common";
import {getQNToken} from "@/utils/CryptoJS";
import {getQNFileKey} from "@/utils/utils";

export default {
    name: "fileDialog",
    props: {
        fileDialog: {
            type: Boolean,
            default: false
        },
        type: {
            type: Number,
        },
        setId: {
            type: Number,
            default() {
                return 0;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {

        return {
            upUrl: FILE_UPLOAD_HOST_QN,
            limit: 1,
            fileList: [],
            fileForm: {
                name: '',
                url: '',
            },
            rules: {
                name: [{required: true, message: '请输入文件名称', trigger: 'blur'}],
                url: [{required: true, message: '请选择上传文件', trigger: 'change'}]
            },
            QiniuData: {
                fname: '', //  文件名
                key: '', //文件名字处理
                token: getQNToken() //七牛云token
            },
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                token: this.user.token,
                addWatermark: 0
            };
        },
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$refs['upload'].clearFiles()
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await articleAdd(
                this.fileForm.name,
                this.fileForm.url,
                this.type,
                this.setId ? this.setId : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$refs['upload'].clearFiles()
            this.$emit("cancelDialog", true);
        },
        //  上传成功
        async handleAvatarSuccess(res) {
            // if (res.status === 200) {
                let _data = await getQiniuUrl(res.key)
                this.fileForm.url = _data.data.url
            // } else {
            //     this.$message.error(res.info)
            //     this.$refs['upload'].clearFiles()
            // }
        },
        // 上传失败
        handleExceed() {
            this.$message.error('请先删除当前已上传的文件')
        },
        //  上传钱判断
        beforeAvatarUpload(file) {
            this.QiniuData.fname = file.name;
            this.QiniuData.key = getQNFileKey(`${new Date().getTime()}${file.name}`)
        },
        //上传文件预览
        handlePreview(file) {
            if (file.url) {
                window.open(file.url)
            } else {
                window.open(file.response.data)
            }
        },
    },
    watch: {
        setItem() {

            this.fileForm = {
                name: this.setItem.name,
                url: this.setItem.url
            };
            if (this.setItem.name) {
                this.fileList = [
                    {
                        name: this.setItem.name,
                        url: this.upUrl + '/' + this.setItem.url
                    }
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
